import React, { Component, Fragment } from 'react';
import { StyleSheet, View } from 'react-native';
import { observer } from 'mobx-react';

import { CombatType, CombatWarriorType } from '../../lib/types';

import Text from '../shared/Text';
import IconButton from '../shared/IconButton';

import { IS_WEB } from '../../lib/appConstants';

import { t, action } from '../../utils/appUtils';

import { RED, BLUE, MARGIN_8, MARGIN_5, TOUCHABLE_7, TOUCHABLE_4, pOrT } from '../styleConstants';

import warriorInfoModalStore from './WarriorInfoModal/store';
import { isWarriorDead } from '../../utils/combatUtils';

type Props = {
  combat: CombatType;
  showHp?: boolean;
  afterTeamRenderer?: Function;
  afterRenderer?: Function;
  beforeRenderer?: Function;
  fetchWarrior?: boolean;
  notListenWarriorChanges?: boolean;
};

const styles = StyleSheet.create({
  infoHp: { fontSize: pOrT(11, 13), marginLeft: MARGIN_5 },
});

@observer
export default class WarriorsLine extends Component<Props> {
  renderWarrior(combatWarrior: CombatWarriorType, team: number, lastOne: boolean) {
    const { showHp, fetchWarrior, notListenWarriorChanges } = this.props;

    const warrior = combatWarrior._warrior;

    return (
      <View
        key={warrior.id}
        style={{
          flexDirection: 'row',
          marginRight: !lastOne ? MARGIN_5 : 0,
          height: 25,
        }}
      >
        <Text
          bold
          style={[
            { color: team === 1 ? BLUE : RED },
            showHp && isWarriorDead(combatWarrior) ? { opacity: IS_WEB ? 0.5 : 0.8 } : null,
          ]}
        >
          {`${warrior.login} [${warrior.level}]`}
        </Text>
        <IconButton
          style={{ marginTop: 2, marginLeft: 4 }}
          onPress={() =>
            action(() => {
              warriorInfoModalStore.toggle(
                !fetchWarrior ? warrior : warrior.id,
                notListenWarriorChanges,
              );
            })
          }
          size={12}
          name="info"
          iconStyle={pOrT(
            {
              width: 14,
              height: 14,
            },
            {
              width: 16,
              height: 16,
            },
          )}
          source={require('../../assets/images/info.png')}
          hitSlop={{
            top: TOUCHABLE_4,
            bottom: 0,
            right: TOUCHABLE_7,
          }}
          title={t('hero.info')}
        />
        {showHp ? (
          <Text bold style={styles.infoHp}>
            {`[${warrior.feature.hp!.current} / ${warrior.feature.hp!.max}]`}
          </Text>
        ) : null}
      </View>
    );
  }

  renderWarriors(team: number) {
    const { combat, afterTeamRenderer } = this.props;

    const warriors = combat.warriors.filter((item) => item.team === team);

    return (
      <Fragment>
        {warriors.map((item, index) =>
          this.renderWarrior(item, team, index === warriors.length - 1),
        )}
        {afterTeamRenderer ? afterTeamRenderer(team) : null}
      </Fragment>
    );
  }

  render() {
    const { beforeRenderer, afterRenderer } = this.props;

    return (
      <View style={[{ flexDirection: 'row', flexWrap: 'wrap' }]}>
        {beforeRenderer ? beforeRenderer() : null}
        {this.renderWarriors(1)}
        <Text style={{ marginHorizontal: MARGIN_8 }}>{t('combat.vs')}</Text>
        {this.renderWarriors(2)}
        {afterRenderer ? afterRenderer() : null}
      </View>
    );
  }
}
